import React from "react";

import './CallUsButton.css';

const CallUsButton = props => {
    const cellphone = "8884131548"
    const handleButtonClick = () => {
        window.location.href = `tel:${cellphone}`;
      };
    return(
   
         <button className="call-us-button" onClick={handleButtonClick} style={{fontSize: '1.1rem', color : 'white', fontWeight: '700', backgroundColor : '#a63f03'}}>
        {props.phonenumber}
        </button>
   
    );
};

export default CallUsButton;